/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Company } from "../models/Company"
import type { ProductPermission } from "../models/ProductPermission"

import type { CancelablePromise } from "../core/CancelablePromise"
import { OpenAPI } from "../core/OpenAPI"
import { request as __request } from "../core/request"

export class CompanyService {
  /**
   * Create Company API Endpoint
   * Create Company
   * @param requestBody
   * @param xAccessToken
   * @returns Company successful operation
   * @throws ApiError
   */
  public static createCompany(
    requestBody: {
      companyName: string
      employerId: string
      ceo: string
      email: string
      postCode: string
      province: string
      city: string
      address?: string
      buildingNo?: string
      phoneNumber: string
      comment?: string
    },
    xAccessToken?: string
  ): CancelablePromise<Company> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/company",
      headers: {
        "x-access-token": xAccessToken,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `No Permission`,
        500: `Internal Server Error`,
      },
    })
  }

  /**
   * List Company API Endpoint
   * List Company
   * @param xAccessToken
   * @param limit
   * @param offset
   * @param orderBy
   * @param sortOrder
   * @returns any successful operation
   * @throws ApiError
   */
  public static listCompanies(
    xAccessToken: string,
    limit?: number,
    offset?: number,
    orderBy?: string,
    sortOrder?: string
  ): CancelablePromise<{
    companies: Array<Company>
    count: number
  }> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/company",
      headers: {
        "x-access-token": xAccessToken,
      },
      query: {
        limit: limit,
        offset: offset,
        orderBy: orderBy,
        sortOrder: sortOrder,
      },
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `No Permission`,
        500: `Internal Server Error`,
      },
    })
  }

  /**
   * Get Company API Endpoint
   * Get Company
   * @param xAccessToken
   * @param companyId
   * @returns Company successful operation
   * @throws ApiError
   */
  public static getCompany(xAccessToken: string, companyId: number): CancelablePromise<Company> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/company/{companyId}",
      path: {
        companyId: companyId,
      },
      headers: {
        "x-access-token": xAccessToken,
      },
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `No Permission`,
        404: `Not Found`,
      },
    })
  }

  /**
   * Update Company API Endpoint
   * Update Company
   * @param companyId
   * @param requestBody
   * @param xAccessToken
   * @returns Company successful operation
   * @throws ApiError
   */
  public static updateCompany(
    companyId: number,
    requestBody: {
      companyName: string
      ceo: string
      email: string
      postCode: string
      province: string
      city: string
      address?: string
      buildingNo?: string
      phoneNumber: string
      comment?: string
    },
    xAccessToken?: string
  ): CancelablePromise<Company> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/v1/company/{companyId}",
      path: {
        companyId: companyId,
      },
      headers: {
        "x-access-token": xAccessToken,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `No Permission`,
        500: `Internal Server Error`,
      },
    })
  }

  /**
   * Delete Company API Endpoint
   * Delete Company
   * @param xAccessToken
   * @param companyId
   * @returns void
   * @throws ApiError
   */
  public static deleteCompany(xAccessToken: string, companyId: number): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/v1/company/{companyId}",
      path: {
        companyId: companyId,
      },
      headers: {
        "x-access-token": xAccessToken,
      },
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `No Permission`,
        404: `Not Found`,
      },
    })
  }

  /**
   * Create Company Product Permission API Endpoint
   * Create Company Product Permission
   * @param companyId
   * @param requestBody
   * @param xAccessToken
   * @returns ProductPermission successful operation
   * @throws ApiError
   */
  public static createCompanyProductPermission(
    companyId: number,
    requestBody: {
      productName: string
    },
    xAccessToken?: string
  ): CancelablePromise<ProductPermission> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/company/{companyId}/permissions",
      path: {
        companyId: companyId,
      },
      headers: {
        "x-access-token": xAccessToken,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `No Permission`,
        500: `Internal Server Error`,
      },
    })
  }

  /**
   * Delete Company Product Permission API Endpoint
   * Delete Company Product Permission
   * @param xAccessToken
   * @param companyId
   * @param permissionId
   * @returns void
   * @throws ApiError
   */
  public static deleteCompanyProductPermission(
    xAccessToken: string,
    companyId: number,
    permissionId: number
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/v1/company/{companyId}/permissions/{permissionId}",
      path: {
        companyId: companyId,
        permissionId: permissionId,
      },
      headers: {
        "x-access-token": xAccessToken,
      },
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `No Permission`,
        404: `Not Found`,
      },
    })
  }
}
